// Column ID constants (ColNo 1-35 from mastersalegrid table)
// These are stable identifiers used by isColVisible() and getColLabel()
// Use these instead of hardcoded column name strings like 'PO No'
export const COL = {
  SR_NO: 1,
  ITEM_CODE: 2,
  DESCRIPTION: 3,
  UNIT: 4,
  PO_NO: 5,
  PO_DATE: 6,
  PO_QTY: 7,
  EX4: 8,
  EX5: 9,
  EX_QTY6: 10,
  TYPE: 11,
  SIZE: 12,
  COLOR: 13,
  BATCH_NO: 14,
  EXP_DATE: 15,
  SERIAL_NO: 16,
  PKG: 17,
  QTY: 18,
  FREE_QTY: 19,
  RATE: 20,
  PER: 21,
  DISC: 22,
  OTH1: 23,
  OTH2: 24,
  OTH3: 25,
  OTH4: 26,
  OTH5: 27,
  OTH6: 28,
  OTH7: 29,
  TAX_CODE: 30,
  UTGST: 31,
  GST_CESS: 32,
  GST_OTH: 33,
  AMOUNT: 34,
  REMARK: 35,
};

// Default English labels for each column (from INITIAL_COLUMNS)
// Used when DisplayLabel is null/empty
export const DEFAULT_LABELS = {
  [COL.SR_NO]: 'Sr No',
  [COL.ITEM_CODE]: 'Item Code',
  [COL.DESCRIPTION]: 'Description',
  [COL.UNIT]: 'Unit',
  [COL.PO_NO]: 'PO No',
  [COL.PO_DATE]: 'PO Date',
  [COL.PO_QTY]: 'PO Qty',
  [COL.EX4]: 'EX4',
  [COL.EX5]: 'EX5',
  [COL.EX_QTY6]: 'EXQty6',
  [COL.TYPE]: 'Type',
  [COL.SIZE]: 'Size',
  [COL.COLOR]: 'Color',
  [COL.BATCH_NO]: 'Batch No',
  [COL.EXP_DATE]: 'Exp. Date',
  [COL.SERIAL_NO]: 'Serial No',
  [COL.PKG]: 'Pkg',
  [COL.QTY]: 'Qty',
  [COL.FREE_QTY]: 'Free Qty',
  [COL.RATE]: 'Rate',
  [COL.PER]: 'Per',
  [COL.DISC]: 'Disc',
  [COL.OTH1]: 'Oth 1',
  [COL.OTH2]: 'Oth 2',
  [COL.OTH3]: 'Oth 3',
  [COL.OTH4]: 'Oth 4',
  [COL.OTH5]: 'Oth 5',
  [COL.OTH6]: 'Oth 6',
  [COL.OTH7]: 'Oth 7',
  [COL.TAX_CODE]: 'Tax Code',
  [COL.UTGST]: 'UTGST',
  [COL.GST_CESS]: 'GST Cess',
  [COL.GST_OTH]: 'GST Oth',
  [COL.AMOUNT]: 'Amount',
  [COL.REMARK]: 'Remark',
};
